import { getMvUrl, getMvComment, getLikeMv } from '@/request/api/item.js';
import LikeMv from '@/components/MusicListItem/LikeMv.vue';
export default {
  name: 'Mv',

  data() {
    return {
      mvid: this.$route.query.id,
      //mvid
      url: null,
      //视频播放路径
      cover: this.$route.query.cover,
      //视频封面
      name: this.$route.query.name,
      //mv名字
      arname: this.$route.query.arname,
      //作者名字
      arurl: this.$route.query.arurl,
      //作者头像路径
      active: 1,
      //导航栏默认选中评论
      commentlist: [],
      //评论列表数据
      likeMvList: [],
      //相似MV列表数据
      isPopups: false,
      //控制弹出层是否弹出
      likeMvId: null //相似MVid

    };
  },

  components: {
    LikeMv
  },

  mounted() {
    this.getmvUrl();
    this.getcomment();
    this.getLike();
  },

  methods: {
    //mv播放地址
    getmvUrl: async function () {
      let data = await getMvUrl(this.mvid);
      console.log(data);
      this.url = data.data.data.url;
    },
    // mv评论
    getcomment: async function () {
      let {
        data: res
      } = await getMvComment(this.mvid);
      console.log(res);
      this.commentlist = res.comments;
    },
    //相似mv
    getLike: async function () {
      let {
        data: res
      } = await getLikeMv(this.mvid);
      console.log(res);
      this.likeMvList = res.mvs;
    },

    play(index) {
      this.isPopups = true; // console.log(index);

      this.likeMvId = this.likeMvList[index].id; // console.log(this.likeMvId);
    }

  }
};